import rebound from 'rebound';
import Particle from './particle.js';
import pointOnRect from '../util/pointOnRect.js';

export default class Particles {

  constructor(ctx, config, width, height) {
    this.ctx = ctx;
    this.width = width;
    this.height = height;

    const { count, sides } = config.particles;
    this.count = count;
    this.sides = sides;

    this.config = config;
    // const { tension, friction } = config.spring;
    // this.tension = tension;
    // this.friction = friction;

    // this.pos = pos;
    // this.life = life;
    // this.origLife = life;
    // this.size = size;
    // this.opacity = opacity;
    // this.force = force;
    // this.generationSpeed = generationSpeed;


    this.init();
  }

  init() {
    this.particles = [];


    this.springSystem = new rebound.SpringSystem();
    console.log(this.count);
    for (let i=0; i < this.count; i++) {
      const particle = new Particle(this.ctx, this.config, this.springSystem);
      this.particles.push(particle);
    }
  }

  destory() {
    if (this.springSystem) this.springSystem.destory();
    this.particles.forEach(p => p.destory());
  }

  set(config) {
    if (!config) return;
    else if (typeof config === "number") {
      //TODO: destory particles (and springsystem?)
      this.count = config;
      this.init();
    }
    else {
      this.config = config;
      this.particles.forEach(p => p.config = config);
    }
  }

  draw() {
    this.resetCanvas();
    this.particles.forEach(p => p.draw());
  }


  update() {
    this.particles.forEach(p => p.update());

    // this.particles = this.particles.filter(p => !p.isDead());
    // if (frameCount % this.generationSpeed === 0) {
    //   this.init();
    // }
  }

  // bang(x, y) {
  //   this.particles.forEach(p => p.pullSpring());
  // }

  // attract(x, y, force, gravity, resize, rotationSpeed, colorSpeed, toColor, ...) {
  attract(area, force, gravity) {
    if (isNaN(force)) force = 0.2;
    if (isNaN(gravity)) gravity = 1;
    // if (isNaN(resize)) resize = 1;
    // if (isNaN(rotationSpeed)) rotationSpeed = 1;

    const count = this.particles.length;
    const shuffled = [].concat(this.particles);
    shuffled.sort(() => force - Math.random());
    shuffled.forEach((p, i) => {
      const pos = p.position;
      // if (i===0) console.log(p);
      const {x, y} = pointOnRect(pos.x, pos.y, area.left, area.top, area.right, area.bottom, false);
      if (i/count < force) p.attract(x, y, gravity);
    });
  }

/*
  pointOnRect(pos, rect) {

    const w = rect.right - rect.left;
    const h = rect.bottom - rect.top;
    // const koter = (w + h) * 2;

    const p = Math.random();
    let x = rect.left;
    let y = rect.top + p * h;
    if (p>0.5) {
      x = rect.left + p * w;
      y = rect.top;
    }

    // if (pos < 0.25)https://openprocessing.org/sketch/138410

    // else if (pos < 0.5)
    // else if (pos < 0.75)
    // else

    // koter * pos

    // if (x > rect.left + w)

    // x += pos;
    // y += pos;
    // w -= pos  * 2
    // h -= pos  * 2
    // if (Math.random() <  w / (w + h)) { // top bottom
    //   x = Math.random() * w + x;
    //   y = Math.random() < 0.5 ? y : y + h -1;
    // } else {
    //   y = Math.random() * h + y;
    //   x = Math.random() < 0.5 ? x: x + w -1;
    // }
    return {x, y};
  }
*/

  unattract() {
    this.particles.forEach(p => p.unattract());
  }


  bump(x, y) {
    this.particles.forEach(p => {
      if (p.isAttracted) {
        // console.log(p);
        const factor = 0.1;
        p.attractTo.x += x * factor;
        p.attractTo.y += y * factor;
        // seedX
        // seedY
        // size

      }
    });
  }
  // rotate(angle) {
  //   this.ctx.rotate(angle * Math.PI / 180);
  // }

  resetCanvas() {
    this.ctx.clearRect(0, 0, this.width, this.height);
    // this.ctx.fillStyle =
    // this.ctx.fillRect(0, 0, this.width, this.height);

  }

  setCanvasSize(width, height) {
    this.width = width;
    this.height = height;

    this.particles.forEach(p => {
      p.setCanvasSize(width, height);
    });


  }
}
